module.exports = __webpack_public_path__ + "static/media/vietnam.9ba95dbd.jpg";